<template>
  <div class="main-survey">
    <div class="survey-title">博智林BIM协同平台</div>
    <div class="survey-brief">产品简介</div>
    <div class="survey-content">
      以BIM数字化建造底层系统为核心，建立具有完全自主知识产权、对标国际的BIM协同平台，以进行模型、图纸、文档的有序管理，多端便捷的在线轻量化浏览与检测，问题实时在线讨论和销项处理。实现项目各环节、各专业、多角色、跨平台的业务在线协同，促进建筑工程项目的效益提升，为建筑数字化、工业化奠定坚实的基础。
    </div>

    <div class="survey-brief">产品功能</div>
    <div
      class="platform-effect"
      v-for="(platformItem, platformIndex) in platformList"
      :key="platformIndex"
    >
      <div class="platform-brief">{{ platformItem.brief }}</div>
      <div class="platform-description">{{ platformItem.description }}</div>
    </div>
    <div class="survey-img">
      <img
        src="@/assets/images/digi-tech/platform-1.png"
        alt="博智林BIM协同平台"
        width="100%"
      />
    </div>
    <div class="survey-brief">应用情况</div>
    <div
      class="survey-apply"
      v-for="(applyItem, applyIndex) in applyList"
      :key="applyIndex"
    >
      {{ applyItem.content }}
    </div>
      <div class="platform-img" v-for="(imgItem,imgIndex) in platformImgList" :key="imgIndex">
      <img
        :src="imgItem.img"
        alt="博智林BIM协同平台"
        width="100%"
      />
    </div>
      <div class="platform-image">
      <img
        src="@/assets/images/digi-tech/platform-5.png"
        alt="博智林BIM协同平台"
        width="100%"
      />
    </div>
    <div class="survey-brief">产品优势</div>
    <div
      class="advantage"
      v-for="(advantageItem, advantageIndex) in advantageList"
      :key="advantageIndex"
    >
      <div class="survey-content ">
        {{ advantageItem.content }}
      </div>
    </div>

    <div class="data-source">*数据来源于博智林数字科技</div>
    <div class="robot-btn" @click="isShow = true">购买联系</div>
    <Qrcode v-model="isShow"></Qrcode>
  </div>
</template>
<script>
import Qrcode from "@/components/Qrcode.vue";

export default {
  name: "digi-platform",
  components: {
    Qrcode,
  },
  data() {
    return {
      isShow: false,
      platformImgList:[
        {
            img:require("@/assets/images/digi-tech/platform-2.png")
        },
         {
            img:require("@/assets/images/digi-tech/platform-3.png")
        },
         {
            img:require("@/assets/images/digi-tech/platform-4.png")
        },
      ],
      applyList: [
        {
          content:
            " • 项目管理员可以通过BIM协同平台对项目资料进行管理，以便设计院精准、及时的上传和下发项目设计成果。",
        },
        {
          content:
            " • 设计阶段：在线审图时，项目组成员可对照设计规范检查模型、图纸问题，在模型上标注视点并记录问题，以便设计师跟进处理。",
        },
        {
          content:
            "  • 施工阶段：施工现场人员可在移动端查看模型、图纸，沟通现场问题。",
        },
      ],
      platformList: [
        {
          brief: "1. 电子文档管理",
          description:
            "设计成果文档统一管理，数据源统一，版本管理清晰、可追溯，支持PC、APP手机、PAD端，方便文档管理操作，提高图模查看、借阅效率；下发、接收精准、实时无延误，减少图模不一致导致的工作误差；文档权限多级管控，文档浏览记录清晰，文档安全有保障。",
        },
        {
          brief: "2. 图模在线轻量化浏览",
          description:
            "兼容多种格式的2D图纸、3D模型、GIS模型在线轻量化、平台化的快速解析、渲染、浏览，用户无需安装各类专业软件，实现建筑工程项目快速、准确作业；支持PC、APP手机、PAD在线轻量化浏览，便于用户随时随地，在各应用场景中浏览和操作图纸、模型，工作便携。",
        },
        {
          brief: "3. 多端在线沟通协同",
          description:
            "设计、生产、交付、运营各项目环节、各专业、多角色、跨平台协同，覆盖各阶段业务场景，多终端信息协同，使业务端到端高效协同。信息同步不滞后，问题解决有闭环。",
        },
      ],
      advantageList: [
           
        {
          content: " • 多文档格式支持",
        },
        {
          content:
            "• 支持各种工程软件",
        },
        {
          content: " • 高品质图模解析与渲染",
        },
        {
          content:
            "• 图型操作功能丰富 ",
        },
        {
          content: " • 集成化数据标准",
        },
        {
          content: "• 插件协同 ",
        },
          {
          content: " • 多终端跨平台 ",
        },
          {
          content: "• 几何算法 ",
        },
      ],
    };
  },
  methods: {},
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/digi.less";
</style>



